import type { LazyModuleDefinition } from '@/types';
import GoogleReCAPTCHA from '@/config/lazyModules.GoogleReCAPTCHA';

// LINT.IfChange
// LINT.Label(lazyModules)
export const modules: Array<LazyModuleDefinition> = [

    /**
     * Mobile navi: Hide on scroll
     */
    {
        id: 'MobileNaviHideOnScroll',
        import: () => import('./../Cms/MobileNavi/HideOnScroll'),
        smallScreensOnly: true,
        selectors: [
            '.sitesmartMobileNavi--hideOnScroll',
        ],
    },

    /*
     * SiteSmart default live search
     */
    {
        id: 'LiveSearch',
        import: () => import("./../Cms/LiveSearch"),
        selectors: [
            "input[data-sitesmart-live-search-1]",
            "input[data-sitesmart-live-search-2]",
        ],
    },

    /**
     * Google ReCAPTCHA
     */
    GoogleReCAPTCHA,

    /**
     * Ecommerce Comparison table
     */
    {
        id: 'EcommerceComparisons',
        import: () => import("./../Ecommerce/Comparisons"),
        selectors: [
            '.sitesmart-ecommerce-add-comparison',
            '.sitesmart-ecommerce-comparisons__scroll',
        ],
    },

    /**
     * Ecommerce Product page comparison functions
     */
    {
        id: 'EcommerceProductComparisons',
        import: () => import("./../Ecommerce/Product/Comparisons"),
        selectors: [
            '.sitesmart-ecommerce-add-comparison',
        ],
    },

    /*
     * SiteSmart Calendar widget
     */
    {
        id: 'CalendarWidget',
        import: () => import("./../Calendar/Widget.ts"),
        selectors: [".sitesmart-calendar-wrapper"],
    },

    /**
     * Cms page popups
     */
    {
        id: 'CmsPagePopup',
        import: () => import('./../Cms/PagePopups'),
        selectors: [
            'body[data-sitesmart-page-popup]',
            'body[data-sitesmart-page-popup-on-blur]',
        ],
    },
];
// LINT.EndLabel
// LINT.ThenChange(/SiteSmart/lib/SiteSmart/SiteSmart/Admin/Module/LazyModules.php#lazyModules)
